import React from 'react';
import Switch from '@material-ui/core/Switch';
import { injectIntl } from 'react-intl';

const FormItemSwitch = ({
    form,
    intl,
    formItemKey,
    initialValue,
    additionalRules = [],
    isRequired = false,
    color = 'primary',
    validateTrigger = 'onChange',
}) => {
    const { getFieldDecorator, getFieldValue } = form;

    const errors = form.getFieldError(formItemKey);

    return (
        <div id="yeself-switch-button">
            {getFieldDecorator(formItemKey, {
                initialValue: Boolean(initialValue),
                validateTrigger,
                preserve: true,
                rules: [
                    {
                        required: isRequired,
                        message: intl.formatMessage({ id: 'Form.field.isRequired' }),
                    },
                    ...(additionalRules && additionalRules.length > 0 ? additionalRules : []),
                ],
            })(<Switch color={color} checked={getFieldValue(formItemKey)} />)}
        </div>
    );
};
export default injectIntl(FormItemSwitch);
